import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/Category.css";
import { BaseUrl } from "../config/api";
import defaultOtherImage from "../assets/images/other-category.png";
import { toHttps } from "../utils/imageUtils";

const OtherCategory = () => {
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [categoriesByType, setCategoriesByType] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch category types
        const categoryTypesResponse = await fetch(
          `${BaseUrl}/categorytypes/allcategorytypes`
        );
        if (!categoryTypesResponse.ok) {
          console.error("Failed to fetch category types:", categoryTypesResponse.status);
          return;
        }
        const categoryTypesData = await categoryTypesResponse.json();

        // Fetch categories
        const categoryResponse = await fetch(
          `${BaseUrl}/categories/allcategory`
        );
        if (!categoryResponse.ok) {
          console.error("Failed to fetch categories:", categoryResponse.status);
          return;
        }
        const categoryData = await categoryResponse.json();

        // Fetch all products
        const productsResponse = await fetch(
          `${BaseUrl}/products/getallproducts`
        );
        if (!productsResponse.ok) {
          console.error("Failed to fetch products:", productsResponse.status);
          return;
        }
        const productsData = await productsResponse.json();

        // Validate that we received arrays
        if (!Array.isArray(categoryTypesData) || !Array.isArray(categoryData) || !Array.isArray(productsData)) {
          console.error("Invalid data format received");
          return;
        }

        // Filter out deleted category types and exclude "Saree" type
        const activeTypes = categoryTypesData.filter(type =>
          !type.isDeleted &&
          type.typeName.toLowerCase() !== "saree"
        );
        setCategoryTypes(activeTypes);

        // Organize categories by type
        const categoryMap = {};

        activeTypes.forEach(type => {
          // Filter categories for this type
          const categoriesForType = categoryData
            .filter(category => {
              // Check if category matches this type and is not deleted
              if (category.categoryTypeId !== type._id || category.isDeleted) {
                return false;
              }

              // Count available products in this category
              const availableProductsCount = productsData.filter(
                product =>
                  !product.isDeleted &&
                  product.categoryName === category.categoryName &&
                  product.stock > 0 &&
                  !product.outOfStock
              ).length;

              // Only include category if it has available products
              return availableProductsCount > 0;
            })
            .map(category => ({
              name: category.categoryName.toUpperCase(),
              image: toHttps(category.categotyImage) || defaultOtherImage,
              path: category.categoryName.toLowerCase().replace(/\s+/g, "-"),
            }));

          // Only add type if it has categories with products
          if (categoriesForType.length > 0) {
            categoryMap[type._id] = {
              typeName: type.typeName,
              categories: categoriesForType
            };
          }
        });

        setCategoriesByType(categoryMap);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {Object.keys(categoriesByType).length > 0 && (
        <>
          {Object.keys(categoriesByType).map(typeId => (
            <div className="other-category-section" key={typeId}>
              <h2 className="category-title">{categoriesByType[typeId].typeName}</h2>
              <div className="other-category-grid">
                {categoriesByType[typeId].categories.map((category, index) => (
                  <Link
                    to={`/category/${category.path}`}
                    key={index}
                    className="saree-category-card"
                  >
                    <div className="category-image-container">
                      <img
                        src={category.image}
                        alt={category.name}
                        onError={(e) => {
                          e.target.src = defaultOtherImage;
                        }}
                      />
                      <div className="category-text-overlay">
                        <h3>{category.name}</h3>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default OtherCategory;
